import { apiProvider } from "@/services/utilities/Provider";

export const ConversationService = {
    getRecruitmentById: (modelId, recruitmentId) =>
        apiProvider.get(`/Workflow/${recruitmentId}`),
    getConversations: (modelId, recruitmentId, page = 1, pageSize = 20, status = null, sortBy = null, sortDirection = null, isFavorite = null, search = null) => {
        const params = new URLSearchParams({ page, pageSize });
        if (status) params.append('status', status);
        if (sortBy) params.append('sortBy', sortBy);
        if (sortDirection) params.append('sortDirection', sortDirection);
        if (isFavorite) params.append('isFavorite', 'true');
        if (search) params.append('search', search);
        return apiProvider.get(`/Interaction/workflow/${recruitmentId}?${params}`);
    },
    getConversationById: (modelId, recruitmentId, conversationId) =>
        apiProvider.get(`/Interaction/${conversationId}`),
    getConversationAttachments: (modelId, recruitmentId, conversationId) =>
        apiProvider.get(`/models/${modelId}/recruitments/${recruitmentId}/conversations/${conversationId}/attachments`),
    downloadAttachmentFile: (interactionId, filename) =>
        apiProvider.download(`/Interaction/${interactionId}/attachments/download/file?name=${encodeURIComponent(filename)}`),
    downloadAllAttachments: (interactionId) =>
        apiProvider.download(`/Interaction/${interactionId}/attachments/download`),
    exportWorkflowCsv: (workflowId, ids = [], status = null, sortBy = null, sortDirection = null, isFavorite = null) =>
        apiProvider.downloadPost(`/Interaction/workflow/${workflowId}/export/xlsx`, {
            ids,
            status: status || null,
            sortBy,
            sortDirection,
            isFavorite: isFavorite || null,
        }),
    toggleFavorite: (interactionId) =>
        apiProvider.patch(`Interaction/${interactionId}/favorite`, {}),
    updateStatus: (interactionId, status) =>
        apiProvider.patch(`Interaction/${interactionId}/status`, { status }),
};
